import {
  applyPostImportBinding,
  type PostImportBindingOutcome,
} from '@/lib/post-import-binding'
import {
  postImportIntegrationCacheKeys,
  revalidateIntegrationCacheKeys,
} from '@/lib/integrations-cache'

type ApplyPostImportBinding = typeof applyPostImportBinding

export async function settlePostImportBinding(args: {
  credentialId: number
  orgId: string
  brandId: string
  result: Parameters<ApplyPostImportBinding>[0]['result']
  onOutcome: (outcome: PostImportBindingOutcome) => void
  onCacheSettled?: () => void
  applyBinding?: ApplyPostImportBinding
  revalidateKeys?: typeof revalidateIntegrationCacheKeys
}): Promise<PostImportBindingOutcome> {
  const outcome = await (args.applyBinding ?? applyPostImportBinding)({
    credentialId: args.credentialId,
    orgId: args.orgId,
    brandId: args.brandId,
    result: args.result,
  })
  args.onOutcome(outcome)
  await (args.revalidateKeys ?? revalidateIntegrationCacheKeys)(
    postImportIntegrationCacheKeys(args.orgId, args.brandId, outcome.status),
  ).catch(() => undefined)
  args.onCacheSettled?.()
  return outcome
}
